export default {
  required: '此欄位必須填寫',
  email: '請輸入有效的電子郵件地址',
  minLength: '此欄位至少需要{min}個字元',
  maxLength: '此欄位不能超過{max}個字元',
  min: '數值必須大於或等於{min}',
  max: '數值必須小於或等於{max}',
  numeric: '此欄位必須是數字',
  integer: '此欄位必須是整數',
  decimal: '此欄位必須是小數',
  alpha: '此欄位只能包含字母',
  alphaNumeric: '此欄位只能包含字母和數字',
  url: '請輸入有效的網址',
  phone: '請輸入有效的電話號碼',
  date: '請輸入有效的日期',
  time: '請輸入有效的時間',
  datetime: '請輸入有效的日期和時間',
  before: '日期必須早於{date}',
  after: '日期必須晚於{date}',
  between: '數值必須在{min}和{max}之間',
  in: '所選的值無效',
  notIn: '所選的值無效',
  confirmed: '確認內容不匹配',
  different: '此值必須與{other}不同',
  same: '此值必須與{other}相同',
  unique: '此值已被使用',
  regex: '此欄位的格式無效',
  custom: '此欄位無效',
  fieldNames: {
    username: '使用者名稱',
    email: '電子郵件',
    password: '密碼',
    confirmPassword: '確認密碼',
    name: '姓名',
    title: '標題',
    description: '描述',
    content: '內容',
    message: '訊息',
    subject: '主旨',
    phone: '電話',
    address: '地址',
    city: '城市',
    country: '國家',
    state: '州/省',
    zipCode: '郵遞區號',
    website: '網站',
    search: '搜尋',
    comment: '評論',
    rating: '評分',
    category: '分類',
    tags: '標籤'
  }
}; 